module.exports = __webpack_public_path__ + "images/_/programs/keepCool/images/characters/apprenticePointingUp3-8de0bd064b02d2e9ed3688e6ef5bec10.png";


//////////////////
// WEBPACK FOOTER
// ./programs/keepCool/images/characters/apprenticePointingUp3.png
// module id = 2436
// module chunks = 2